module.exports = __webpack_public_path__ + "male-icon-active.8272a44b60be3f2d7d66.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/male-icon-active.svg
// module id = ../../../../../src/assets/images/male-icon-active.svg
// module chunks = main